import { NEWS_BOARD_INFO, NEWS_BOARD_INFO_TAB, NEWS_BOARD_INFO_MOBILE } from 'assets/json/newsInfo.js'
import NewsBannerSwiper from '../../components/swiper/NewsBannerSwiper'
import { URL } from '../../utils/Utils'
import './NewsMain.scss'
import { useMediaQuery } from 'react-responsive'

/**
 * @file 고객지원 main 화면
 */
function NewsMain() {
    const isMobile = useMediaQuery({ maxWidth: 768 })
    const isTab = useMediaQuery({ maxWidth: 1279 })

    const newsBoardInfo = isMobile ? NEWS_BOARD_INFO_MOBILE : isTab ? NEWS_BOARD_INFO_TAB : NEWS_BOARD_INFO

    return (
        <>
            <div className="news-one">
                <NewsBannerSwiper />
            </div>
            <div className="news-two">
                <div className="news-list-wrap">
                    {newsBoardInfo.map(val => (
                        <a href={URL.NEWS.BOARD_DETAIL + URL.SEARCH_ID + val.id} key={'news-list-' + val.id}>
                            <div className="img-box" style={{ backgroundImage: 'url(' + val.imgUrl + ')' }} />
                            <div className="text-box">
                                <div className="t1" dangerouslySetInnerHTML={{ __html: val.title }}></div>
                                <div className="sub" dangerouslySetInnerHTML={{ __html: val.sub }}></div>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </>
    )
}

export default NewsMain
